//
// locale_cs.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/cs.json';
import localeData from "react-intl/locale-data/cs.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
